import React, { useState } from 'react'
import { MDBRow, MDBCol } from 'mdb-react-ui-kit'

const FormModalCreateGrupo = () => {
    const [form, setForm] = useState({
        groupName: '',
        groupColor: '',
        group: '',
        company: '',
        contract: '',
    })

    const handleChange = e => {
        const { name, value } = e.target
        setForm(f => ({ ...f, [name]: value }))
    }

    const submit = e => {
        e.preventDefault()
        // Aquí puedes manejar el envío del formulario
        console.log('Formulario enviado:', form)
    }

    return (
        <div>
            {/* Nombre GroupID */}
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Nombre GroupID:</label>
                    <input
                        type="text"
                        name="groupName"
                        className="form-control"
                        placeholder="Ingrese nombre"
                        value={form.groupName}
                        onChange={handleChange}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>

            {/* Color GroupID */}
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Color GroupID:</label>
                    <input
                        type="text"
                        name="groupColor"
                        className="form-control"
                        placeholder="Ingrese color"
                        value={form.groupColor}
                        onChange={handleChange}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>

            {/* Lista Group */}
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Lista Group:</label>
                    <select
                        name="group"
                        className="form-control"
                        value={form.group}
                        onChange={handleChange}
                        style={{ boxSizing: 'border-box' }}
                    >
                        <option value="">-Seleccione Grupo-</option>
                        {/* …otros grupos */}
                    </select>
                </MDBCol>
            </MDBRow>

            {/* Lista Empresas */}
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Lista Empresas:</label>
                    <select
                        name="company"
                        className="form-control"
                        value={form.company}
                        onChange={handleChange}
                        style={{ boxSizing: 'border-box' }}
                    >
                        <option value="">-TODOS-</option>
                        {/* …otras empresas */}
                    </select>
                </MDBCol>
            </MDBRow>

            {/* Lista Contratos */}
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Lista Contratos:</label>
                    <select
                        name="contract"
                        className="form-control"
                        value={form.contract}
                        onChange={handleChange}
                        style={{ boxSizing: 'border-box' }}
                    >
                        <option value="">
                            SERV-00451669 - 776250222472 - SMLU790125-0
                        </option>
                        {/* …otros contratos */}
                    </select>
                </MDBCol>
            </MDBRow>
            <div className="d-flex justify-content-end">
                <button className='btn-primary-modals-maestros' onClick={submit}>
                    Guardar
                </button>
            </div>
        </div>

    )
}

export default FormModalCreateGrupo
